import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import type { SignInFormData, AuthResponse, AuthError } from "../types/auth";
import singUp from "../api/singUp";
import { storageName } from "../../../constans/auth";

export const useSignUp = (): UseMutationResult<
  AuthResponse,
  AuthError,
  SignInFormData
> => {
  return useMutation({
    mutationFn: singUp,
    onSuccess: ({ status, data, message }) => {
      // Store token and user data (implement storage logic)
      localStorage.setItem(storageName, JSON.stringify(data));
    },
    onError: (error) => {
      console.error("Sign in error:", error);
    },
  });
};
